import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import type React from "react";
import { ProfileSettingPassword } from "~/components/specifics/vendors/settings/profiles/ProfileSettingPassword";
import { ProfileSettingVendorUser } from "~/components/specifics/vendors/settings/profiles/ProfileSettingVendorUser";

export const ProfileSetting: React.FC = () => (
	<Panel>
		<PanelHeader title="プロフィール詳細" />
		<PanelBody>
			<ProfileSettingVendorUser />
			<ProfileSettingPassword />
		</PanelBody>
	</Panel>
);
